import { faClose } from '@fortawesome/pro-regular-svg-icons/faClose'
import { faShare } from '@fortawesome/pro-regular-svg-icons/faShare'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import SharePost from '../single-blog-post/SharePost'

interface ShareButtonProps {
  title: string
  link: string
}

export default function ShareButton({
  title,
  link,
}: ShareButtonProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="relative">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="rounded px-4 py-2 bg-v5-yellow bg-opacity-80 hover:bg-opacity-90 font-bold text-white inline-flex items-center gap-4 cursor-pointer right-0"
      >
        Share{' '}
        <div className="w-4">
          <FontAwesomeIcon icon={isOpen ? faClose : faShare} />
        </div>
      </div>

      <div
        className={`absolute w-44 bg-white text-black px-4 py-2 shadow rounded-md right-0 top-full mt-2 z-20 transition-opacity ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <SharePost title={title} link={link} />
      </div>
    </div>
  )
}
